/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoStore {
    'use strict';

    interface IHomeController {

    }

    class HomeController implements IHomeController{
        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            '$q',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            'meevo.plugins.meevoStore.MeevoStoreService',
            'meevo.components.common.IdentityService',
            'meevo.ContextParams'
        ];

        public routeMeevoStore: string;
        public accountInfo: IStoreAccountInfo;
        public currentEdition: IStoreEdition;
        public currentMessage: IMessageOption;
        public isInCallCenterLocation: boolean;
        public accessLevelSalesForce: AccessLevelEnum;
        public canShow: boolean;

        constructor(
            protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: ng.ui.IStateService,
            protected $q: angular.IQService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected storeService: Meevo.Plugins.MeevoStore.IMeevoStoreService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            contextParams: Meevo.ContextParamsService
        ) {

            this.routeMeevoStore = this.appSettings.ROUTE_NAMES.meevoStore;

            if (contextParams && contextParams.params && contextParams.params.linkType) {
                if (contextParams.params.linkType === LinkType.BusinessBoosters) {
                    this.openAddons();
                    return;
                }
            }

            this.storeService.getAccountInfo().then((data) => {
                this.accountInfo = data;
                this.updateCurrentPlans();
                this.accessLevelSalesForce = this.accountInfo.accessLevel;
            });
            this.canShow = this.identityService.isSingleLocation();
            this.isInCallCenterLocation = this.identityService.inCallCenterMode() && !this.identityService.isEmulating;
            if (!this.identityService.current().isSingleLocation) {
                if (this.$state.current.name == "meevoStore.home") {
                    this.$state.current.sticky = null;
                }
               this.openAccount();
            }
        }

        public updateCurrentPlans (): void {

            this.currentEdition = _.find(this.accountInfo.meevoEditions, (el) => {
                return el.editionPlanId == this.accountInfo.currentEditionId;
            });

            this.currentMessage = _.find(this.accountInfo.messageOptions, (el) => {
                return el.smsPlanId == this.accountInfo.currentMessageId;
            });
        }

        public openAccount() {
           // if (this.accessLevelSalesForce == AccessLevelEnum.Admin)
            this.$state.go(this.appSettings.ROUTE_NAMES.meevoStore + '.account');
        }

        public openAddons () {
            //if (this.accessLevelSalesForce == AccessLevelEnum.Admin)
            this.$state.go(this.appSettings.ROUTE_NAMES.meevoStore + '.addons');
        }

        public openIntegrations() {
            //if (this.accessLevelSalesForce == AccessLevelEnum.Admin)
            this.$state.go(this.appSettings.ROUTE_NAMES.meevoStore + '.integrations');
        }

        public openHardware() {
            //if (this.accessLevelSalesForce == AccessLevelEnum.Admin)
            this.$state.go(this.appSettings.ROUTE_NAMES.meevoStore + '.hardware');
        }

        public goBack () {
            this.$state.go('^');
        }
    }
    angular.module('meevo.plugins.meevoStore')
        .controller('meevo.plugins.meevoStore.HomeController', HomeController);
}